import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    cat: '👤 Inscription & Compte',
    questions: [
      { q: "Comment s'inscrire sur ELIM DEPANNAGE ?", a: "Cliquez sur « S'inscrire » en haut de la page. Choisissez votre type de compte (Client ou Prestataire), remplissez le formulaire avec vos informations et validez. Vous recevrez un email de confirmation." },
      { q: "L'inscription est-elle gratuite ?", a: "Oui, l'inscription est entièrement gratuite pour les clients et les prestataires." },
      { q: "J'ai oublié mon mot de passe, que faire ?", a: "Cliquez sur « Connexion » puis sur « Mot de passe oublié ». Entrez votre email et vous recevrez un lien de réinitialisation." },
      { q: "Puis-je modifier mes informations après l'inscription ?", a: "Oui, depuis votre espace personnel, vous pouvez modifier votre profil, photo, numéros de téléphone et autres informations à tout moment." },
    ]
  },
  {
    cat: '🔧 Trouver un prestataire',
    questions: [
      { q: "Comment trouver un mécanicien près de moi ?", a: "Sur la page d'accueil, sélectionnez le type de service (mécanique moto, voiture, vulcanisateur...) et entrez votre ville. La plateforme affichera les prestataires disponibles près de vous." },
      { q: "Les prestataires sont-ils vérifiés ?", a: "Oui, chaque prestataire doit fournir son numéro CIP lors de l'inscription. Notre équipe vérifie les documents avant de valider le compte prestataire." },
      { q: "Comment contacter un prestataire ?", a: "Depuis le profil du prestataire, vous pouvez lui envoyer un message directement via la plateforme ou utiliser son numéro WhatsApp si disponible." },
      { q: "Que signifie la note des prestataires ?", a: "La note est calculée à partir des avis laissés par les clients après chaque prestation. Elle va de 1 à 5 étoiles." },
    ]
  },
  {
    cat: '💳 Paiements',
    questions: [
      { q: "Comment payer un prestataire ?", a: "Les paiements s'effectuent via Mobile Money : MTN Mobile Money, Moov Money ou Celtiis Cash. Une fois la prestation terminée, vous recevez une notification de paiement." },
      { q: "Mon paiement est-il sécurisé ?", a: "Oui, toutes les transactions sont sécurisées par protocole SSL 256-bit. Nous ne stockons jamais vos informations bancaires." },
      { q: "Puis-je obtenir un remboursement ?", a: "En cas de litige, vous pouvez ouvrir un recours dans les 48h suivant la prestation en nous contactant. Les remboursements sont traités sous 3 à 5 jours ouvrables." },
    ]
  },
  {
    cat: '🔩 Pour les Prestataires',
    questions: [
      { q: "Comment devenir prestataire sur ELIM DEPANNAGE ?", a: "Cliquez sur « S'inscrire » et choisissez « Prestataire ». Renseignez vos spécialités, votre zone d'intervention, votre numéro CIP et vos coordonnées Mobile Money pour recevoir vos paiements." },
      { q: "Combien coûte l'inscription comme prestataire ?", a: "L'inscription est gratuite. ELIM DEPANNAGE perçoit uniquement une commission sur les prestations réalisées via la plateforme." },
      { q: "Comment recevoir mes paiements ?", a: "Vous recevez vos paiements directement sur votre numéro Mobile Money (MTN, Moov ou Celtiis) renseigné lors de l'inscription." },
      { q: "Que faire si un client ne paie pas ?", a: "Signalez le cas via la messagerie de la plateforme. Notre équipe interviendra pour résoudre le litige dans les 24h." },
    ]
  },
  {
    cat: '⚠️ Problèmes & Support',
    questions: [
      { q: "Que faire si le prestataire ne se présente pas ?", a: "Contactez-nous immédiatement via email à elimdepannage@gmail.com ou par WhatsApp. Nous vous aiderons à trouver un autre prestataire disponible." },
      { q: "Comment signaler un prestataire ?", a: "Depuis le profil du prestataire, cliquez sur « Signaler ». Notre équipe examinera la plainte dans les 24h." },
      { q: "Comment supprimer mon compte ?", a: "Contactez-nous à elimdepannage@gmail.com avec votre demande de suppression. Votre compte et vos données seront supprimés sous 7 jours ouvrables." },
    ]
  },
];

function FAQItem({ question, answer }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: '1px solid var(--gray-mid)' }}>
      <button
        onClick={() => setOpen(!open)}
        style={{ width: '100%', textAlign: 'left', padding: '1.1rem 0', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem' }}
      >
        <span style={{ fontWeight: 600, color: 'var(--blue-dark)', fontSize: '0.95rem', lineHeight: 1.4 }}>{question}</span>
        <ChevronDown size={18} style={{ color: 'var(--orange)', flexShrink: 0, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }} />
      </button>
      {open && (
        <div style={{ paddingBottom: '1.1rem', color: '#555', lineHeight: 1.8, fontSize: '0.9rem' }}>
          {answer}
        </div>
      )}
    </div>
  );
}

export default function FAQPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa', paddingTop: '100px', paddingBottom: '4rem' }}>
      <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '0 1.5rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2.5rem', color: 'var(--blue-dark)', marginBottom: '0.8rem' }}>
            QUESTIONS FRÉQUENTES
          </h1>
          <p style={{ color: 'var(--gray-text)', fontSize: '1rem' }}>
            Tout ce que vous devez savoir sur ELIM DEPANNAGE
          </p>
        </div>

        {faqs.map((cat, i) => (
          <div key={i} style={{ background: 'white', borderRadius: '16px', padding: '2rem', boxShadow: '0 4px 24px rgba(0,0,0,0.06)', marginBottom: '1.5rem' }}>
            <h2 style={{ fontFamily: 'var(--font-cond)', fontSize: '1.1rem', color: 'var(--orange)', marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
              {cat.cat}
            </h2>
            {cat.questions.map((item, j) => (
              <FAQItem key={j} question={item.q} answer={item.a} />
            ))}
          </div>
        ))}

        <div style={{ background: 'var(--blue-dark)', borderRadius: '16px', padding: '2rem', textAlign: 'center', color: 'white', marginTop: '2rem' }}>
          <h3 style={{ fontFamily: 'var(--font-display)', marginBottom: '0.5rem' }}>Vous n'avez pas trouvé votre réponse ?</h3>
          <p style={{ opacity: 0.7, marginBottom: '1.2rem', fontSize: '0.9rem' }}>Notre équipe est disponible pour vous aider</p>
          <a href="mailto:elimdepannage@gmail.com" className="btn btn-primary">Contactez-nous</a>
        </div>

        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
          <Link to="/" style={{ color: 'var(--orange)', fontWeight: 600 }}>← Retour à l'accueil</Link>
        </div>
      </div>
    </div>
  );
}
